import { render, staticRenderFns } from "./transfer-client-profile-modal.vue?vue&type=template&id=b67d8a08"
import script from "./transfer-client-profile-modal.vue?vue&type=script&lang=js"
export * from "./transfer-client-profile-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports